import { Box, Circle, Float, Image } from '@chakra-ui/react'
import useEmblaCarousel from 'embla-carousel-react'

import { TakePhotoStepImageData } from 'components/partials/individualOrder/IndividualOrderItemInfo/components/pickupReturnFlow/utils/models'
import { LeidButtonWhiteOutlined } from 'components/ui/Buttons/Button'
import XIcon from 'public/icons/x.svg'

import 'swiper/css'
import './styles.css'

import { usePrevNextButtons } from './ArrowButtons'
import { DotButton, useDotButton } from './DotButtons'
import NavIcon from './NavIcon'

type Props = {
  images: TakePhotoStepImageData[]
  handleImageDelete: (index: number) => void
}

const ImagesSlider = ({ images, handleImageDelete }: Props): JSX.Element => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ active: true, slidesToScroll: 'auto' })
  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi)
  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi)

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {images.map((image, index) => (
            <div className="embla__slide" key={index}>
              <Box key={`box_${index}`} display="flex" justifyContent="center" position="relative" height="100%">
                {image.sequenceIndex !== undefined && (
                  <Float placement="bottom-end" offsetX="5" offsetY="5">
                    <Circle size="6" bg="green.a200" color="white">
                      {image.sequenceIndex + 1}
                    </Circle>
                  </Float>
                )}

                <Float style={{ zIndex: 9999 }} offsetX="7" offsetY="7">
                  <LeidButtonWhiteOutlined key={`button_${index}`} onClick={() => handleImageDelete(index)}>
                    <XIcon key={`x_${index}`} />
                  </LeidButtonWhiteOutlined>
                </Float>

                <Image
                  className="embla__slide__number"
                  key={`image_${index}`}
                  // width="50px"
                  objectFit={'cover'}
                  alt="Asset photo"
                  src={URL.createObjectURL(image.imageBlob) || '/images/placeholder.png'}
                />
              </Box>
            </div>
          ))}
        </div>
      </div>

      <div className="embla__controls">
        <div className="embla__buttons">
          <NavIcon type="prev" onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NavIcon type="next" onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>

        <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={'embla__dot'.concat(index === selectedIndex ? ' embla__dot--selected' : '')}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default ImagesSlider
